const SOURCE_NOT_SELECTED = 'Please select "Event Type"';

export const eventTypeValidation = (eventType: string): string[] => {
    const errorMassages = [];

    if (!eventType) {
        errorMassages.push(SOURCE_NOT_SELECTED);
    }

    return errorMassages;
};
